import { Country } from '@superbet-group/web.types';
import { transformComtradePromotion } from './transformComtradePromotion';
import { transformBetlerPromotion } from './transformBetlerPromotion';
import { Promotion } from '../types/Promotion';
import { ComtradePromotionDto } from '../types/dtos/ComtradePromotionDto';
import { BetlerPromotionDto } from '../types/dtos/BetlerPromotionDto';

export const transformPromotion: Record<Country, (promotion: any) => Promotion | null> = {
    [Country.Ro]: (promotion: ComtradePromotionDto) => transformComtradePromotion(promotion),
    [Country.RoNapoleon]: (promotion: BetlerPromotionDto) => transformBetlerPromotion(promotion),
    [Country.Pl]: (promotion: ComtradePromotionDto) => transformComtradePromotion(promotion),
    [Country.Com]: (promotion: BetlerPromotionDto) => transformBetlerPromotion(promotion),
    [Country.Br]: (promotion: BetlerPromotionDto) => transformBetlerPromotion(promotion),
    [Country.BrSocial]: (promotion: BetlerPromotionDto) => transformBetlerPromotion(promotion),
    [Country.Rs]: (promotion: BetlerPromotionDto) => transformBetlerPromotion(promotion),
    [Country.Be]: (promotion: BetlerPromotionDto) => transformBetlerPromotion(promotion),
    [Country.Bg]: (promotion: BetlerPromotionDto) => transformBetlerPromotion(promotion),
};
